import {Injectable} from '@angular/core';
import {ServiceBase} from './base.service';
import {IUserDetail} from "../models/user-detail.model";
import {ParsedError} from "./parsed-error";
import {ToastrService} from 'ngx-toastr';
import {HttpClient} from '@angular/common/http';
import {MonitoringService} from "./monitoring.service";
import {IUserDeletionPreview} from '../models/user-deletion-preview.model';

@Injectable()
export class MembersService extends ServiceBase {

    private apiUrl = 'user/';

    constructor(protected http: HttpClient,
                protected monitoringService: MonitoringService,
                protected toastrService: ToastrService) {
        super(http, monitoringService, toastrService);
    }

    getOne(id, callback: (isSuccess: boolean, result?: IUserDetail, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'GetOne';
        this.http.get<IUserDetail>(callUrl,
            {
                params: {
                    "id": id
                }
            })
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    // TODO
                    callback(false, {}, this.handleError(error, id));
                });
    }

    getAll(callback: (isSuccess: boolean, result?: IUserDetail[], error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'GetAll';
        this.http.get<Array<IUserDetail>>(callUrl)
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    // TODO
                    callback(false, null, this.handleError(error));
                });
    }


    getDeletePreview(email: string,
                     callback: (isSuccess: boolean, result?: IUserDeletionPreview, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'GetDeletePreview';
        this.http.get<IUserDeletionPreview>(callUrl,
            {
                params: {
                    "email": email
                }
            })
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    callback(false, null, this.handleError(error, {email: email}));
                });
    }


    setMemberSetting(email: string, settingName: string, valueToSet: boolean, callback: (success: boolean, result?: IUserDetail, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'Set' + settingName;
        this.http.post<IUserDetail>(callUrl, {
            email: email,
            valueToSet: valueToSet
        })
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    // TODO
                    callback(false, {}, this.handleError(error, {
                        email: email,
                        settingName: settingName,
                        valueToSet: valueToSet
                    }));
                });
    }

    reject(email: string, callback: (success: boolean, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'Reject';
        this.http.post<IUserDetail>(callUrl, email)
            .subscribe(
                _result => {
                    callback(true, null);
                },
                error => {
                    // TODO
                    callback(false, this.handleError(error, email));
                });
    }

    deleteUser(email: string, reason: string, callback: (success: boolean, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'DeleteUser';
        this.http.post(callUrl, {email: email, reason: reason})
            .subscribe(
                _result => {
                    callback(true, null);
                },
                error => {
                    callback(false, this.handleError(error, {email: email}));
                });
    }

    changeEmail(email: string, newEmail: string, callback: (success: boolean, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'ChangeEmail';
        this.http.post<IUserDetail>(callUrl, {originalEmail: email, newEmail: newEmail})
            .subscribe(
                result => {
                    callback(true, null);
                },
                error => {
                    callback(false, this.handleError(error, email));
                });
    }

    validateEmailChange(email: string, newEmail: string, callback: (success: boolean, result?: {
        error: any;
        canProceed: boolean, validationType?: string, firstName?: string, lastName?: string, email?: string
    }, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'ValidateEmailChange';
        this.http.post<{
            canProceed: boolean,
            error: string,
            validationType?: string,
            firstName?: string,
            lastName?: string,
            email?: string
        }>(callUrl, {
            originalEmail: email,
            newEmail: newEmail
        })
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    callback(false, null, this.handleError(error, {email: email, newEmail: newEmail}));
                });
    }


    addCredits(email: string, amount: number, callback: (success: any, result: IUserDetail, error: ParsedError) => void) {
        const callUrl = this.apiUrl + 'AddCredits';
        this.http.post<IUserDetail>(callUrl, {
            email: email,
            creditToAdd: amount
        })
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    // TODO
                    callback(false, {}, this.handleError(error, {email: email, amount: amount}));
                });
    }

    unsubscribe(email: string, callback: (success: boolean, result: IUserDetail, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'Unsubscribe';
        this.http.post<IUserDetail>(callUrl, email)
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    // TODO
                    callback(false, {}, this.handleError(error, email));
                });
    }

    resubscribe(email: string, callback: (success: boolean, result: IUserDetail, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'Resubscribe';
        this.http.post<IUserDetail>(callUrl, email)
            .subscribe(
                result => {
                    callback(true, result, null);
                },
                error => {
                    // TODO
                    callback(false, {}, this.handleError(error, email));
                });
    }
}
